import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Review from './Reviews';
import './Reviews.scss'


export default function RewiewsBlock(){

    const reviews = [
        {
            "name": "Світлана",
            "course": "Підготовка до школи",
            "text": " Вже місяць, як мій син проходить курс підготовки до школи — і результати радують! Читає швидше, навчився складати склади в слова, рахує приклади і на додавання, і на віднімання. Став уважнішим, краще зосереджується. Окреме дякую за ігрову платформу — вчиться із задоволенням. Тепер я спокійна: до школи він піде з інтересом і впевненістю ❤️ Дякую Вам ❤️"
        },
        {
            "name": "Альона",
            "course": "Ментальна арифметика",
            "text": " Дуже вдячна Smartum за цікаві корисні заняття! Син помітив, що він таки застосовує вміння та навики, набуті на ментальній арифметиці - на уроках з математики. Йому подобається викладач та його колеги у групі"
        },
        {
            "name": "Анна",
            "course": "Таблиця множення",
            "text": "Хочу подякувати академії Smartum та викладачу за курс Таблиця множення! Сину дуже сподобалось займатись, без проблем, сліз, нервів вивчив табличку і тепер всі щасливі і ми, як батьки і син і вчитель в школі!"
        },
        {
            "name": "Ірина",
            "course": "Ментальна арифметика",
            "text": "Нам все до вподоби, син хоче навчитись рахувати швидше тата, дуже старається)))"
        },
        {
            "name": "Марина",
            "course": "Ментальна арифметика",
            "text": "Донечці дуже сподобалося, пробне заняття хотіла продовжувати ще і ще, мало було години 😁 Дякуємо за неймовірну можливість спробувати і зрозуміти чи сподобається донечці ♥️"
        },
        {
            "name": "Олена",
            "course": "",
            "text": "Пройшли пробний урок. Гарний фахівець. Син дуже задоволений, хоче займатись і це для нас головне! Вчитель відразу знайшла контакт з дитиною"
        },
        {
            "name": "Марина",
            "course": "Підготовка до школи",
            "text": "Прийшли в жовтні. Літери знала але не всі. Склади не могла з'єднувати, навчились тільки у вас) зараз читаємо все підряд 😁"
        },
        {
            "name": "Вікторія",
            "course": "Ментальна арифметика",
            "text": "Моя дитина в захваті. Вже всім родичам і сусідам розповідає як вона рахує. Після першого уроку. Сподіваюсь, так і далі буде☺️"
        },
    ]

    return(
        <div className="ReviewBlock">
            <Swiper
             breakpoints={{
            // when window width is >= 640px
            300: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 768px
            640: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // when window width is >= 1024px
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
                 modules={[Navigation, Pagination, Scrollbar, A11y]}
                navigation
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
            >

                {reviews.map((el, index) => {
                    return <SwiperSlide key={index}>
                        <Review  name={el.name} text={el.text} course={el.course} />
                    </SwiperSlide>
                })}
            </Swiper>
        </div>
    )
}